<template>
  <div v-if="loaded">
    <section style="padding-top: 20px; text-align: center;">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <h1>{{ env }}Payment Request</h1>
          </div>
        </div>
      </div>
    </section>

    <div v-if="paymentLoaded">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <p style="text-align: center;">
              You have been requested to make a payment to your account. Please
              make the payment using the form below
            </p>
          </div>
        </div>

        <div class="row" style="text-align: center">
          <div class="col-md-3 col-xs-12"></div>
          <div class="col-md-6 col-xs-12" id="payment-element">
            <h2>Make Payment</h2>

            <div
              class="block tabular"
              style="padding: 20px; position: relative;"
            >
              <p v-if="!paymentComplete">
                <strong>Account:</strong> {{ this.account }}
              </p>

              <PaymentChoice
                ref="paymentChoice"
                gtag-reference="BillingPayRequest"
                :allow-further-payment="false"
                :ignore-capture="true"
                :is-credit="true"
                @complete="resetPayment"
              ></PaymentChoice>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaymentChoice from "@/views/Components/Payment/PaymentChoice.vue";

export default {
  name: "paymentCredit",
  components: { PaymentChoice },
  props: ["id"],
  data() {
    return {
      loaded: false,
      paymentLoading: false,
      payment: {},
      paymentComplete: false,
      paymentLoaded: false,
      account: null
    };
  },
  computed: {
    env() {
      return process.env.VUE_APP_ENV;
    }
  },
  created() {
    this.$store.dispatch("loaderCancel");
    this.fetchData();
  },
  methods: {
    resetPayment() {
      this.paymentComplete = true;
    },
    fetchData() {
      const title = "Fetching Payment";
      const subtitle = "Getting payment details";
      this.$store.dispatch("loaderInitiate", { title, subtitle });

      const reference = this.id;

      this.$store
        .dispatch("getPaymentCredit", { reference })
        .then(response => {
          this.payment = response.data;
          this.paymentLoaded = true;

          this.account = response.data.account;

          this.loaded = true;

          this.$nextTick(() => {
            this.$refs.paymentChoice.loadPayment(
              response.data.secret,
              this.payment.amount
            );
          });
        })
        .catch(err => {
          let msg = "Invalid link for payment";
          if (err.response.data.message) {
            msg = err.response.data.message;
          }
          this.$swal({
            title: "Invalid Request",
            text: msg + ". If this problem persists please contact us",
            type: "error",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "OK"
          }).then(result => {
            if (result.value) {
              this.$router.push("/login");
            }
          });
        })
        .finally(() => {
          this.$store.dispatch("loaderCancel");
        });
    }
  }
};
</script>

<style lang="scss" scoped>
h2 {
  font-size: 1.6rem !important;
  text-align: center !important;
  margin-bottom: 10px !important;
  padding-left: 10px;
  margin-top: 20px;
}

.row {
  margin-top: 20px;
  margin-bottom: 20px;
}

h1 {
  font-size: 1.6rem;
}

@media (min-width: 576px) {
  h1 {
    font-size: 2.5rem;
  }
}
</style>
